'use client';

import type { ReactNode } from 'react';
import type { IToggle } from 'unleash-proxy-client';
import { createContext, use } from 'react';

const UnleashContext = createContext<IToggle[]>([]);

export function useUnleashToggles() {
  return use(UnleashContext);
}

interface Props {
  children: ReactNode;
  bootstrap?: IToggle[];
}

export function UnleashProvider({ children, bootstrap = [] }: Props) {
  return <UnleashContext value={bootstrap}>{children}</UnleashContext>;
}
